// Motivos disponíveis para a justificativa de um chamado no Portal de
// Justificativas. Lista extensível — começamos com um único motivo e vamos
// acrescentando conforme a operação definir novos.
//
// `cod` é o valor persistido em justificativaInfo.motivo (Request.js);
// `descricao` é o rótulo exibido nos dropdowns.
const MotivoJustificativa = [
    { cod: "ausencia-tecnica", descricao: "Ausência técnica" },
    { cod: "balanceamento", descricao: "Balanceamento" },
    { cod: "configuracao", descricao: "Configuração" },
    { cod: "reserva-tecnica", descricao: "Reserva técnica" },
    { cod: "encerramento-tecnico", descricao: "Encerramento Técnico" },
    { cod: "estoque-deficiente", descricao: "Estoque deficiente" },
    { cod: "falha-operacional", descricao: "Falha operacional" },
    { cod: "necessario-analise-prime", descricao: "Necessário análise Prime" },
    { cod: "ok", descricao: "OK" },
    { cod: "sem-historico-movimentacao", descricao: "Sem histórico de movimentação" },
    { cod: "unidade-especifica", descricao: "Unidade específica" },
    { cod: "implantacao", descricao: "Implantação" },
];

export default MotivoJustificativa;
